// extracted by mini-css-extract-plugin
export default {"root":"Video_root__R3JS5","video":"Video_video__Fp8So"};